import React from "react";
import { ContactBtn } from "../components/ContactBtn";

// InvestmentCard Component

const InsuranceCard = ({ title, description, content }) => (
  <div className="bg-white rounded-lg shadow-md p-6 flex flex-col">
    <h3 className="text-xl font-semibold text-red-500">{title}</h3>
    <p className="text-gray-700 mt-4">{description}</p>
    <ul className="list-disc list-inside mt-4 text-gray-700 space-y-2">
      {content.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  </div>
);

//

//
// InvestmentPage Component
const InvestmentPage = () => {
  const insuranceData = [
    {
      title: "Life Insurance",
      description:
        "Provides financial security to your loved ones in case of an unfortunate event.",
      content: [
        "Term Insurance: High coverage at an affordable premium.",
        "Whole Life Insurance: Lifelong protection and cash value.",
        "Endowment Plans: Combines savings with insurance.",
        "ULIPs: Investment and insurance for wealth creation.",
      ],
    },
    {
      title: "Health Insurance",
      description:
        "Covers medical expenses, ensuring quality healthcare without financial stress.",
      content: [
        "Individual Health Plans: Single individual coverage.",
        "Family Floater Plans: Covers the whole family.",
        "Critical Illness Insurance: Lump sum for critical illnesses.",
        "Senior Citizen Plans: Designed for individuals above 60.",
      ],
    },
    {
      title: "Motor Insurance",
      description:
        "Protects against financial losses from accidents, theft, or third-party liabilities.",
      content: [
        "Third-Party Insurance: Covers third-party liabilities.",
        "Comprehensive Insurance: Covers own vehicle and liabilities.",
        "Two-Wheeler Insurance: Specialized for bikes and scooters.",
      ],
    },
    {
      title: "Property Insurance",
      description:
        "Protects your property against natural disasters, theft, or damage.",
      content: [
        "Home Insurance: Covers damage from fire, theft, floods, or earthquakes.",
        "Commercial Property Insurance: Protects business premises and equipment.",
      ],
    },
    {
      title: "Travel Insurance",
      description:
        "Covers unexpected events while traveling, ensuring a hassle-free experience.",
      content: [
        "Domestic Travel Insurance: Covers trips within the country.",
        "International Travel Insurance: Covers medical emergencies, trip cancellations, or lost luggage abroad.",
      ],
    },
    {
      title: "Business Insurance",
      description:
        "Protects businesses from financial risks, ensuring continuity during unforeseen events.",
      content: [
        "Liability Insurance: Covers claims from third parties due to business activities.",
        "Property Insurance: Protects business premises and inventory.",
        "Employee Benefits Insurance: Group health or life insurance for employees.",
      ],
    },
    {
      title: "Personal Accident Insurance",
      description:
        "Provides financial support in case of accidental death or disability.",
      content: [
        "Covers medical expenses.",
        "Provides loss of income due to disability.",
        "Death benefits for dependents.",
      ],
    },
    {
      title: "Marine Insurance",
      description:
        "Covers goods, ships, and cargo against damages during transit by sea.",
      content: [
        "Protection against natural disasters.",
        "Coverage for piracy or accidents at sea.",
      ],
    },
  ];

  return (
    <div className="bg-gray-50 text-gray-800 min-h-screen mt-10 overflow-clip">
      {/* Main Content */}
      <main className="container mx-auto py-12 space-y-12">
        {/* Introduction Section */}

        <section className="bg-red-600 text-white text-center py-16 pt-20">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Insurance Is Your Protection
          </h1>
          <p className="text-lg m-auto mb-6 max-w-[900px] ">
            Insurance is your safeguard, offering financial security and peace
            of mind against unexpected events for individuals and businesses
            alike.
          </p>
          <ContactBtn label={"Secure your future today"} />
        </section>

        {/* Available Investments Section */}
        <section>
          <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
            Our Investment Options
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-4">
            {insuranceData.map((item, index) => (
              <InsuranceCard
                key={index}
                title={item.title}
                description={item.description}
                content={item.content}
              />
            ))}
          </div>
        </section>

        {/* Call-to-Action Section */}
        <section className="bg-red-500 text-white md:rounded-lg shadow-md p-8 text-center">
          <h2 className="text-3xl font-bold mb-4">Want To Know More?</h2>
          <p className="text-lg leading-relaxed mb-6">
            Insurance is a financial agreement between individuals or businesses
            and an insurance provider to safeguard against potential risks and
            uncertainties.
          </p>
          <ContactBtn label={"Get Insurance Details"} />
        </section>
      </main>
    </div>
  );
};

export default InvestmentPage;
